/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import queryString from "query-string"
import { TWijmoCellTemplateContext, TWijmoComboBox } from "../../../type/wijmoComponents"
import { useEffect, useState } from "react"
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import { useDispatch } from "react-redux"

import AlertComponent from "../../../components/AlertComponent"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import DaiyoZyomuinTeateService from "../../../service/billing/DaiyoZyomuinTeate/daiyoZyomuinTeateService"
import {
  TDaiyoZyomuinTeateListGetReq,
  TDaiyoZyomuinTeateListGetRes,
  TDaiyoZyomuinTeatePutReq,
} from "../../../service/billing/DaiyoZyomuinTeate/TDaiyoZyomuinTeate"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { showInfoToast } from "../../../components/CustomToast"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import HinmeiSearchModal from "../../../components/SearchModal/HinmeiSearchModal"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import { 区分分類コード } from "../../../constant/enum/codes"
import KubunService from "../../../service/master/kubun/kubunService"
import { TApiResponse } from "../../../service/TApiResponse"
import TextInput from "../../../components/InputWrapper/TextInput"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import stringUtil from "../../../ts/util/stringUtil"
import ComboBox from "../../../components/ComboBox"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import {
  TNinusiInfoGetRes,
  荷主マスタ,
} from "../../../service/master/ninusi/TNinusi"
import { TNinusiSeikyuListGetRes } from "../../../service/master/ninusiseikyu/TNinusiSeikyu"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import RequiredHeader from "../../../components/FlexGridWrapper/RequiredHeader"
import Ajv from "ajv"
import ajvErrors from "ajv-errors"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { DaiyoZyomuinTeatePutReqSchema } from "../../../service/billing/DaiyoZyomuinTeate/DaiyoZyomuinTeateSchema"

//#region [type]

export type T乗務員手当入力GridItem = TDaiyoZyomuinTeateListGetRes &
  Partial<{
    行ID: symbol
  }>

//#endregion

type T在籍区分Item = { name: string; value: string }
const 在籍区分List: T在籍区分Item[] = [
  { name: "在籍", value: "0" },
  { name: "退職", value: "1" },
]

/**
 * 太陽 乗務員手当マスタ登録
 * @returns
 */
const DaiyoZyomuinTeateRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "DaiyoZyomuinTeateRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T乗務員手当入力GridItem>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {},

      newItemCreator() {
        return {
          大陽社員コード: "",
          日当: 0,
          酸素単価: 0,
          窒素単価: 0,
          アルゴン単価: 0,
          距離単価: 0,
          行ID: Symbol(),
        } as unknown as Partial<T乗務員手当入力GridItem>
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TDaiyoZyomuinTeateListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に

    // 処理対象荷主をクリア
    set処理対象荷主コード("")

    let currentSearchCondition: TDaiyoZyomuinTeateListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new DaiyoZyomuinTeateService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      set処理対象荷主コード(currentSearchCondition.荷主)
      setGridData({ data: createCollectionView(res.data, pageSize) })

      // 荷主請求を設定
      const 荷主請求Res = await new NinusiSeikyuService().getList({
        荷主コード: currentSearchCondition.荷主,
        削除済み包含フラグ: true,
      })

      const 荷主請求List = [
        ...荷主請求Res.data.map((d) => ({
          ...d,
          displayMemberPath: `${d.表紙分割コード}: ${d.表紙名}`,
        })),
      ]

      const new荷主請求DataMap = new wjcGrid.DataMap(
        荷主請求List,
        "荷主請求ID",
        "displayMemberPath"
      )

      new荷主請求DataMap.getDisplayValues = (
        dataItem: typeof 荷主請求List[number]
      ) => {
        let filteredSource = 荷主請求List.filter((h) => h.廃止日 == null)
        return filteredSource.map((h) => h.displayMemberPath)
      }

      set荷主請求DataMap(new荷主請求DataMap)
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = async () => {
    const parsed = queryString.parse(location.search)
    const 在籍区分Value =
      parsed.在籍区分 !== undefined ? Number(parsed.在籍区分) : 0
    const query: TDaiyoZyomuinTeateListGetReq = {
      荷主: "",
      ...parsed,
      在籍区分: 在籍区分Value,
    }
    set在籍区分(在籍区分Value.toString())
    await search荷主(query.荷主)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TDaiyoZyomuinTeateListGetReq => {
    return {
      荷主: 荷主コード ?? "",
      在籍区分:
        在籍区分 != null && 在籍区分 !== "" ? Number(在籍区分) : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TDaiyoZyomuinTeateListGetReq
  ) => {
    return {
      荷主CD: wjCore.isNullOrWhiteSpace(searchCondition.荷主)
        ? ""
        : searchCondition.荷主,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    disPatch(clearAlert())
  }

  const clearSearchState = () => {
    set荷主コード("")
    set荷主名("")
    set処理対象荷主コード("")
    set在籍区分("0")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.beginningEdit.addHandler(beginningEdit)
    grid.pastingCell.addHandler(pastingCell)
    grid.formatItem.addHandler(formatItem)

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
        cell.style.textAlign = "center"
      }
    }

    grid.refresh()
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const dataItem = e.getRow().dataItem as T乗務員手当入力GridItem
    const isNew = (dataItem.大陽乗務員単価ID ?? 0) === 0
    let col = s.columns[e.col]

    switch (col.binding as keyof T乗務員手当入力GridItem) {
      case "荷主請求ID":
        e.cancel = !isNew
        break
    }
  }
  const pastingCell = beginningEdit

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      // 削除フラグ
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const dataItem = e.getRow().dataItem as T乗務員手当入力GridItem
        const binding = e.getColumn().binding as keyof T乗務員手当入力GridItem
        const header = e.getColumn().header

        const row = e.getRow()
        row.isReadOnly = dataItem.削除フラグ === 1
        wjCore.toggleClass(e.cell, "read-only-cell", dataItem.削除フラグ === 1)

        // エラーセルの色変え
        if (
          errorCellPositionList.find(
            (e) => e.colBinding === binding && e.行ID === dataItem.行ID
          )
        ) {
          wjCore.toggleClass(e.cell, "data-warning", true)
          return
        }

        const isNew = (dataItem.大陽乗務員単価ID ?? 0) === 0

        // isReadOnly
        switch (binding) {
          case "社員氏名":
          case "車輌ID":
          case "荷主品名ID":
          case "品名":
            wjCore.toggleClass(e.cell, "read-only-cell", true)
            break
          case "荷主請求ID":
            wjCore.toggleClass(e.cell, "read-only-cell", !isNew)
            break
          default:
            break
        }

        // isReadOnly
        switch (header) {
          case "乗務員CD":
            wjCore.toggleClass(e.cell, "read-only-cell", true)
            break
          default:
            break
        }
      }
    }
  }

  const createPutReqDataList = (): Array<{
    行ID: symbol
    reqData: TDaiyoZyomuinTeatePutReq
  }> => {
    const retItems: Array<{ 行ID: symbol; reqData: TDaiyoZyomuinTeatePutReq }> =
      gridData.data.sourceCollection.map((d: T乗務員手当入力GridItem) => {
        const newReq: TDaiyoZyomuinTeatePutReq = {
          大陽乗務員単価ID: d.大陽乗務員単価ID ?? undefined,
          荷主請求ID: d.荷主請求ID,
          乗務員コード: d.社員コード,
          車輌ID: d.車輌ID,
          距離設定区分コード: d.距離設定区分コード,
          大陽社員コード: d.大陽社員コード,
          日当: d.日当 ?? 0,
          酸素単価: d.酸素単価 ?? 0,
          窒素単価: d.窒素単価 ?? 0,
          アルゴン単価: d.アルゴン単価 ?? 0,
          距離単価: d.距離単価 ?? 0,
          荷主品名ID: d.荷主品名ID,
          削除フラグ: d.削除フラグ ?? 0,
          更新日時: d.更新日時,
        }
        return {
          行ID: d.行ID,
          reqData: newReq,
        }
      })
    return retItems
  }

  const beforeSubmit = () => {
    const errorMessages: string[] = []

    // Gridエラークリア
    errorCellPositionList.splice(0, errorCellPositionList.length)

    let schema = DaiyoZyomuinTeatePutReqSchema
    const putReqDataList = createPutReqDataList()
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)

    // 一行ごとにチェック
    putReqDataList.forEach((data, i) => {
      const 行ID = data.行ID
      const reqData = data.reqData

      // 削除行はチェックしない
      if (reqData.削除フラグ === 1) return

      const validate = ajv.compile(schema)
      const validateResult = validate(reqData)

      if (!validateResult) {
        const errors = validate.errors
        if (errors != null && errors.length > 0) {
          errors.forEach((error) => {
            // エラー項目名を取得
            let colBinding = error.instancePath.slice(1)
            if (stringUtil.isNullOrWhiteSpace(colBinding)) {
              // error.instancePathで取得できない場合(undefinedでrequiredErrorの場合)
              // 型が不明な error.params の中にあるMissingPropertyを利用する
              if (Array.isArray(error.params?.errors)) {
                const innerErrors = error.params?.errors as any[]
                if (innerErrors.length !== 0) {
                  colBinding = innerErrors[0]?.params?.missingProperty
                }
              }
            }

            // Gridのエラー位置を設定
            if (
              !errorCellPositionList.find(
                (e) => e.行ID === 行ID && e.colBinding === colBinding
              )
            ) {
              errorCellPositionList.push({ 行ID: 行ID, colBinding })
            }

            // エラーメッセージを設定
            if (!stringUtil.isNullOrWhiteSpace(error.message)) {
              if (!errorMessages.some((m) => m === error.message))
                errorMessages.push(error.message!)
            }
          })
        }
      }
    })

    if (errorMessages.length === 0) {
      setIsConfirmModalShow(true)
    } else {
      disPatch(setWarningAlerts(errorMessages))
      flexGrid?.refresh()
    }
  }

  // TODO:PUTのみ？
  const submit = async () => {
    try {
      const service = new DaiyoZyomuinTeateService()
      let res: TApiResponse<boolean>
      let dataList: Array<TDaiyoZyomuinTeatePutReq> = []

      gridData.data.sourceCollection.forEach((d: T乗務員手当入力GridItem) => {
        let data: TDaiyoZyomuinTeatePutReq = {
          大陽乗務員単価ID: d.大陽乗務員単価ID ?? undefined,
          荷主請求ID: d.荷主請求ID,
          乗務員コード: d.社員コード,
          車輌ID: d.車輌ID,
          距離設定区分コード: d.距離設定区分コード,
          大陽社員コード: d.大陽社員コード,
          日当: d.日当 ?? 0,
          酸素単価: d.酸素単価 ?? 0,
          窒素単価: d.窒素単価 ?? 0,
          アルゴン単価: d.アルゴン単価 ?? 0,
          距離単価: d.距離単価 ?? 0,
          荷主品名ID: d.荷主品名ID,
          削除フラグ: d.削除フラグ,
          更新日時: d.更新日時,
        }
        dataList.push(data)
      })

      res = await service.put(dataList)
      disPatch(setAlerts(res))
      if (res) {
        showInfoToast("乗務員手当マスタの更新が完了しました。")
      }
      // 遷移してきた際のクエリパラメータで検索条件を生成
      const querySearchCondition = await queryParse()

      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      search(querySearchCondition).finally(() => {
        disPatch(画面ロック解除())
      })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //useEffect内ではasyncが使用できないため外部に記述
  const search荷主 = async (荷主コード?: string) => {
    if (stringUtil.isNullOrWhiteSpace(荷主コード)) {
      update荷主State(undefined)
      return
    }
    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード,
        完全一致フラグ: true,
      })

      if (荷主res != null && 荷主res.data.length === 1) {
        update荷主State(荷主res.data[0])
      } else {
        update荷主State(undefined)
      }
    } catch (error) {
      dispatch(setAlerts(error))
      update荷主State(undefined)
    }
  }

  const update荷主State = (
    ninusiInfo: TNinusiInfoGetRes | 荷主マスタ | undefined
  ) => {
    if (ninusiInfo == null) {
      // 荷主コードはクリアしない
      // set荷主コード("")
      set荷主名("")
    } else {
      set荷主コード(ninusiInfo.荷主コード)
      set荷主名(ninusiInfo.荷主略称1)

      setモーダル検索用荷主コード(ninusiInfo.荷主コード)
      setモーダル検索用荷主名(ninusiInfo.荷主略称1)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  // modal
  const [選択行, set選択行] = useState<wjcGrid.Row>()
  const [モーダル検索用荷主コード, setモーダル検索用荷主コード] = useState<
    string | undefined
  >()
  const [モーダル検索用荷主名, setモーダル検索用荷主名] = useState<
    string | undefined
  >()

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [在籍区分, set在籍区分] = useState<string | null>(null)
  const [在籍区分ComboBox, set在籍区分ComboBox] =
    useState<TWijmoComboBox<string, T在籍区分Item> | null>(null)
  const [在籍区分IsLoadEnded, set在籍区分IsLoadEnded] =
    useState<boolean>(false)

  // 車番検索
  const [is車番検索Modal, setIs車番検索Modal] = useState(false)

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState<boolean>(false)

  // 距離設定区分検索
  const [距離設定区分DataMap, set距離設定区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  // 荷主請求Column用DataMap
  const [荷主請求DataMap, set荷主請求DataMap] =
    useState<wjcGrid.DataMap<TNinusiSeikyuListGetRes>>()

  // 品名検索
  const [is品名検索Modal, setIs品名検索Modal] = useState(false)

  //grid内エラー項目格納Array
  const [errorCellPositionList] = useState<
    Array<{ 行ID: symbol; colBinding: string }>
  >([])

  // 処理対象の荷主管理用
  const [処理対象荷主コード, set処理対象荷主コード] = useState<string>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `大陽 乗務員手当マスタ登録`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
  }, [])

  useEffect(() => {
    // 区分取得
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set距離設定区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.距離設定区分
          ),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 在籍区分IsLoadEnded) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        queryParse().then((querySearchCondition) => {
          // リストア中フラグON
          setIsRestoreSearching(true)

          // 再検索
          search(querySearchCondition).finally(() => {
            disPatch(画面ロック解除())
          })
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        // 在籍区分の初期値を「在籍」(=0) に設定する。
        // ComboBox.Default の defaultValue は isAllSelect と併用すると、
        // itemsSource 反映時に先頭「すべて」へ選択がリセットされて効かないため、
        // ロード完了後にコンボと state の両方へ明示的に設定する。
        if (在籍区分ComboBox != null) {
          在籍区分ComboBox.selectedValue = "0"
        }
        set在籍区分("0")
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 在籍区分IsLoadEnded])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">大陽 乗務員手当マスタ登録</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card>
            <Card.Body>
              <Form>
                <Container fluid className="contents-search-main">
                  <div className="search-condition-table">
                    <div className="search-condition-row">
                      <div className="input-group">
                        <TextInput
                          autoFocus={true}
                          style={{ width: "6rem" }}
                          id="荷主コード"
                          name="荷主コード"
                          value={荷主コード}
                          setValue={(v) => {
                            set荷主コード(v)
                          }}
                          onBlur={(e) => {
                            search荷主(e.target.value)
                          }}
                          maxLength={5}
                          placeholder="荷主CD"
                        />
                        <button
                          type="button"
                          className="icon-button"
                          title="荷主検索"
                          onClick={(e) => {
                            e.preventDefault()
                            setIs荷主検索Modal(true)
                          }}>
                          <FontAwesomeIcon
                            className="icon-button-inner"
                            icon={faSearch}></FontAwesomeIcon>
                        </button>
                        <TextInput
                          style={{ width: "16.1rem" }}
                          id="荷主名"
                          isReadOnly={true}
                          name="荷主名"
                          value={荷主名}
                          setValue={set荷主名}
                          maxLength={100}
                          placeholder="荷主名"
                        />
                      </div>
                      <ComboBox.Default
                        className="max-w-10rem"
                        placeholder="在籍区分"
                        isAllSelect={true}
                        // 初期値「在籍」は defaultValue では効かない（isAllSelect と
                        // 併用すると itemsSource 反映時に「すべて」へリセットされる）。
                        // 通常遷移時の初期化 useEffect 内で明示的に設定している。
                        itemsSource={在籍区分List}
                        selectedValue={在籍区分}
                        setSelectedValue={set在籍区分}
                        isLoadEnded={在籍区分IsLoadEnded}
                        setIsLoadEnded={set在籍区分IsLoadEnded}
                        ComboBox={在籍区分ComboBox}
                        setComboBox={set在籍区分ComboBox}
                      />
                      <Button
                        type="submit"
                        disabled={isSearching}
                        style={{ alignSelf: "center" }}
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          // Enterによるsubmit時に他ControlでのonBlur発火用
                          e.currentTarget.focus()
                          search()
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                        検索
                      </Button>
                    </div>
                  </div>
                </Container>
              </Form>
            </Card.Body>
          </Card>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                isEnablePageSize={"hidden"}
                hasFilter={false}
                gridProperties={{
                  isDisabled: stringUtil.isNullOrWhiteSpace(処理対象荷主コード),
                  allowSorting: wjcGrid.AllowSorting.None,
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <div className="d-flex">
                    <Button
                      type="submit"
                      disabled={stringUtil.isNullOrWhiteSpace(
                        処理対象荷主コード
                      )}
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </div>
                }>
                <wjrGrid.FlexGridColumn
                  binding="荷主請求ID"
                  width={180}
                  align={"left"}
                  dataMap={荷主請求DataMap}
                  header="荷主請求">
                  <RequiredHeader></RequiredHeader>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="乗務員コード"
                  header="乗務員CD"
                  cssClass="read-only-cell"
                  isReadOnly={true}>
                  <RequiredHeader></RequiredHeader>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員手当入力GridItem>
                    ) => {
                      const isNew = (context.item.大陽乗務員単価ID ?? 0) === 0
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.社員コード}
                          </div>
                          {isNew && (
                            <div className="text-end">
                              <a
                                href="*"
                                onClick={(e) => {
                                  e.preventDefault()
                                  set選択行(context.row)
                                  setIs乗務員検索Modal(true)
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </a>
                            </div>
                          )}
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="社員氏名"
                  width={150}
                  header="乗務員名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌ID"
                  header="車番"
                  cssClass="read-only-cell"
                  isReadOnly={true}>
                  <RequiredHeader></RequiredHeader>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員手当入力GridItem>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">{context.item.車番}</div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                //   TODO:コード未確定
                                e.preventDefault()
                                set選択行(context.row)
                                setIs車番検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="大陽社員コード"
                  width={128}
                  header="大陽社員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="距離設定区分コード"
                  width={140}
                  dataMap={距離設定区分DataMap}
                  header="距離設定区分">
                  <RequiredHeader></RequiredHeader>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主品名ID"
                  width={80}
                  cssClass="read-only-cell"
                  isReadOnly={true}
                  header="品名CD">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員手当入力GridItem>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.品コード}
                          </div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                e.preventDefault()
                                set選択行(context.row)
                                setIs品名検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="品名"
                  width={140}
                  header="品名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="日当"
                  width={90}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="日当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="酸素単価"
                  width={90}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="酸素単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="窒素単価"
                  width={90}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="窒素単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="アルゴン単価"
                  width={90}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="アルゴン単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="距離単価"
                  width={90}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="距離単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="削除フラグ"
                  width={70}
                  align="center"
                  header="在籍">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員手当入力GridItem>
                    ) => (
                      <span>{context.item.削除フラグ === 0 ? "在籍" : "退職"}</span>
                    )}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  align={"center"}
                  binding="Row_id"
                  width={80}
                  isReadOnly={true}
                  header=" ">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<T乗務員手当入力GridItem>
                    ) => {
                      // Store反映前に削除ボタン使えないため、row_idの有無も制御に加える
                      const boundItem: T乗務員手当入力GridItem = context.item
                      return boundItem.削除フラグ !== 1 ? (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          variant={"waiting"}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()

                            if (gridData == null || gridData.data == null)
                              return
                            if (boundItem) {
                              if (boundItem.大陽乗務員単価ID) {
                                gridData.data.beginUpdate()
                                boundItem.削除フラグ = 1
                                gridData.data.endUpdate()
                                gridData.data.commitEdit()
                              } else {
                                gridData.data.remove(boundItem)
                              }
                            }
                          }}>
                          削除
                        </Button>
                      ) : (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          variant={"pending"}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            if (gridData == null || gridData.data == null)
                              return
                            if (boundItem) {
                              if (boundItem.大陽乗務員単価ID) {
                                gridData.data.beginUpdate()
                                boundItem.削除フラグ = 0
                                gridData.data.endUpdate()
                                gridData.data.commitEdit()
                              }
                            }
                          }}>
                          解除
                        </Button>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で 荷主CD:{処理対象荷主コード} のマスタを更新しますか？
      </ConfirmModal>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          update荷主State(荷主)
        }}></NinusiSearchModal>
      {/* 車番検索 */}
      <SyaryoSearchModal
        isShow={is車番検索Modal}
        setIsShow={setIs車番検索Modal}
        setSyaryo={(車輌) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T乗務員手当入力GridItem = 選択行.dataItem

            casted.車輌ID = 車輌.車輌ID ?? 0
            casted.車番 = 車輌.車番 ?? ""
            flexGrid?.refresh()
          }
        }}></SyaryoSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T乗務員手当入力GridItem = 選択行.dataItem
            casted.乗務員ID = 乗務員.乗務員ID
            casted.社員コード = 乗務員.社員コード
            casted.社員氏名 = 乗務員.社員氏名
            flexGrid?.refresh()
          }
        }}></ZyomuinSearchModal>
      {/* 品名検索 */}
      <HinmeiSearchModal
        size="lg"
        setIsShow={setIs品名検索Modal}
        isShow={is品名検索Modal}
        ninusiCode={モーダル検索用荷主コード}
        ninusiName={モーダル検索用荷主名}
        isNinusiReadOnly={true}
        setHinmei={(品名) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T乗務員手当入力GridItem = 選択行.dataItem
            casted.荷主品名ID = 品名.荷主品名ID
            casted.品コード = 品名.品コード
            casted.品名 = 品名.品名
            flexGrid?.refresh()
          }
        }}></HinmeiSearchModal>
    </Container>
  )
}

export default DaiyoZyomuinTeateRegister
